export default [
    {
        path: "hourly-server-connection",
        name: "hourlyserverconnection",
        component: () =>
            import(
                /* webpackChunkName: "hourlyserverconnection" */ "../pages/hourlyServerConnectionReport/HourlyServerConnectionReport.vue"
            ),
        meta: {
            title: `Server Connection`,
        },
    }
];
